import React from 'react';
import DetailPane from './DetailPane';
import { useTheme } from '../context/ThemeContext';

const MobilePreviewModal = ({
  isOpen,
  onClose,
  selectedFile,
  selectedCaseStudy,
  ABOUT,
  SKILLS,
  CASE_STUDIES,
  PROFILE_DATA
}) => {
  const { colors } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 lg:hidden backdrop-blur-sm">
      <div
        className="w-full h-full overflow-hidden flex flex-col"
        style={{ backgroundColor: colors.background }}
      >
        <div
          className="p-6 flex justify-between items-center"
          style={{ borderBottom: `1px solid ${colors.border}` }}
        >
          <h3 className="text-lg font-medium" style={{ color: colors.textPrimary }}>
            {selectedFile ?
              selectedFile.replace('_', ' ').replace('.pdf', '') :
              selectedCaseStudy || 'Preview'}
          </h3>
          <button
            onClick={onClose}
            className="text-xl hover:opacity-80 transition-opacity"
            style={{ color: colors.textSecondary }}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>
        <div className="flex-1 overflow-auto px-2 py-6">
          <DetailPane
            selectedFile={selectedFile}
            selectedCaseStudy={selectedCaseStudy}
            ABOUT={ABOUT}
            SKILLS={SKILLS}
            CASE_STUDIES={CASE_STUDIES}
            PROFILE_DATA={PROFILE_DATA}
            isMobile={true}
          />
        </div>
      </div>
    </div>
  );
};

export default MobilePreviewModal;
